"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");

























































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _skillItemList = _interopRequireDefault(require("./skillItemList")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { name: 'Skill', components: { SkillItem: _skillItemList.default }, data: function data() {return { tableData: [], // 列表数据
      newadd: false, itemListShow: false, title: '', skillId: '', searchData: { name: '', code: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', sn: '', icon: '', name: '' }, rules: { name: [{ required: true, message: '请输入技能名称', trigger: 'blur' }], code: [{ required: true, message: '请输入技能编码', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'code', label: '技能编码', isShow: true }, { prop: 'name', label: '技能名称', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', formatter: _formatter.dateFormatter, isShow: true }] };}, mounted: function mounted() {var self = this;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/robot/skill', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, getOrganziationList: function getOrganziationList() {var self = this;self.getData('/api/institution/dropList/0', {}, function (res) {self.organizationList = res;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.code = '';this.searchData.name = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, addFun: function addFun() {// 新增
      this.title = '新增';this.newadd = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.newadd2 = false;}, updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';var self = this;self.newadd = true;self.addData = { id: item.id, name: item.name, code: item.code };}, onSubmit: function onSubmit() {// 新增提交操作
      var self = this;self.$refs.addForm.validate(function (valid) {if (valid) {
          self.postData('/api/temi/robot/skill', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/robot/skill?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        name: '',
        code: '' };

    },
    closeItemDialog: function closeItemDialog() {
      this.itemListShow = false;
    },
    openItemDialog: function openItemDialog(skillId) {
      var self = this;
      this.skillId = skillId;
      this.itemListShow = true;
      console.log('skillId：' + this.skillId);
      if (self.$refs.itemRef) {
        self.$refs.itemRef.getItem(skillId);
      }
    },
    changeItemShow: function changeItemShow(res) {
      console.log('修改' + res);
      this.itemListShow = false;
    } } };exports.default = _default;